"use client";
import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { Logo } from "@/assets/icons/Icons";
import Link from "next/link";
import { motion, AnimatePresence } from "framer-motion";
import { LanguageSelector } from "../templates/LangSelector";

export default function Navbar() {
  const t = useTranslations("Navbar");
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { name: t("link1"), path: "/#brand" },
    { name: t("link2"), path: "/#stat" },
    { name: t("link3"), path: "/#contact" },
    { name: t("link4"), path: "/#contact" },
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        event.target instanceof Element &&
        !event.target.closest(".menu") &&
        !event.target.closest(".logo")
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-white shadow-md">
      <div className="container flex justify-between items-center xl:px-[5rem] lg:px-[3.125rem] md:px-[1.875rem] px-4 xl:pt-[1.25rem] pt-4 xl:pb-[1.125rem] relative">
        {/* Logo */}
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="cursor-pointer mx-auto md:mx-0 logo py-2"
        >
          <Link href={"#top"}>
            <Logo className="w-[4.125rem] h-[3.5rem]" />
          </Link>
        </div>

        {/* Desktop links and language selector */}
        <div className="hidden md:flex xl:gap-10 lg:gap-8 gap-4">
          {links.map((link, index) => (
            <Link
              key={index}
              href={link.path}
              className="xl:text-[1.25rem] text-base font-medium hover:text-primary"
            >
              {link.name}
            </Link>
          ))}
        </div>
        <div className="hidden md:block">
          <LanguageSelector />
        </div>

        {/* Mobile Sidebar Menu */}
        <div className="md:hidden">
          <AnimatePresence mode="wait">
            {isOpen && (
              <>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="fixed inset-0 bg-black/80 z-40"
                  onClick={() => setIsOpen(false)}
                />

                <motion.div
                  initial={{ x: "-100%" }}
                  animate={{ x: 0 }}
                  exit={{ x: "-100%" }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 30,
                    duration: 0.5,
                  }}
                  className="fixed top-0 left-0 w-[60%] h-full bg-white shadow-lg p-6 z-50 menu"
                >
                  <Logo className="w-[4.125rem] h-[3.5rem] mb-6" />
                  {links.map((link, index) => (
                    <Link
                      key={index}
                      href={link.path}
                      className="block text-lg font-medium mb-4 hover:text-primary transition-colors duration-200"
                      onClick={() => setIsOpen(false)}
                    >
                      {link.name}
                    </Link>
                  ))}
                  <div className="mt-6">
                    <LanguageSelector />
                  </div>
                </motion.div>
              </>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
